import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/multiLocationSagas";
import ReactDatePicker from "../../../components/reactDatePicker/reactDatePicker";
import { useDateFormat } from "../../../hooks/useDateFormat";

const PreviousDatePicker = ({ calendarStartDate }) => {
  const dispatch = useDispatch();
  const dateFormat = useDateFormat();

  const { prevStartDate, prevEndDate, prevCalendarEndDate } = useSelector(
    (state) => state.multiLocation.selectedRequestPrevDates
  );

  const handleUpdateDates = (startDate, endDate) => {
    dispatch(
      actionCreators.updatePrevDates({
        prevStartDate: startDate,
        prevEndDate: endDate,
        prevCalendarEndDate
      })
    );
  };

  return prevStartDate ? (
    <div className="date-select-box multi" style={{ width: 317 }}>
      <p>Previous</p>
      <ReactDatePicker
        displayFormat={dateFormat}
        isRangePicker
        startDate={prevStartDate}
        endDate={prevEndDate}
        calendarEndDate={prevCalendarEndDate}
        minDate={calendarStartDate}
        updateDates={handleUpdateDates}
      />
    </div>
  ) : null;
};

export default PreviousDatePicker;
